export const phoneNumber = "8668588736"
export const email = "info@techdarshak.com"